import React, { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import './PDFViewer.css';

// Set up PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFViewer = ({ url, onClose }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // Pre-fetch the PDF to check for CORS issues
    fetch(url, { mode: 'cors' })
      .then(response => {
        if (!response.ok) throw new Error('Failed to load PDF');
        setLoading(false);
      })
      .catch(err => {
        console.error('PDF fetch error:', err);
        setError('Failed to load PDF. Please try again.');
        setLoading(false);
      });
  }, [url]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setLoading(false);
  }

  function onDocumentLoadError(error) {
    console.error('PDF load error:', error);
    setError('Failed to load PDF. Please try again.');
    setLoading(false);
  }

  const handlePrevPage = () => {
    setPageNumber(page => Math.max(page - 1, 1));
  };

  const handleNextPage = () => {
    setPageNumber(page => Math.min(page + 1, numPages));
  };

  const handleZoomIn = () => {
    setScale(scale => Math.min(scale + 0.2, 3));
  };

  const handleZoomOut = () => {
    setScale(scale => Math.max(scale - 0.2, 0.5));
  };

  return (
    <div className="pdf-viewer-overlay" onClick={onClose}>
      <div className="pdf-viewer-container" onClick={e => e.stopPropagation()} ref={containerRef}>
        <div className="pdf-viewer-toolbar">
          <div className="pdf-viewer-controls">
            <button onClick={handleZoomOut} disabled={loading || error}>-</button>
            <span>{Math.round(scale * 100)}%</span>
            <button onClick={handleZoomIn} disabled={loading || error}>+</button>
            <span className="page-controls">
              <button onClick={handlePrevPage} disabled={pageNumber <= 1 || loading || error}>←</button>
              <span>Page {pageNumber} of {numPages || '?'}</span>
              <button onClick={handleNextPage} disabled={pageNumber >= numPages || loading || error}>→</button>
            </span>
          </div>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="pdf-document-container">
          {loading && <div className="loading">Loading PDF...</div>}
          {error && <div className="error">{error}</div>}
          {!error && (
            <Document
              file={url}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={onDocumentLoadError}
              loading={<div className="loading">Loading PDF...</div>}
            >
              <Page
                pageNumber={pageNumber}
                scale={scale}
                loading={<div className="loading">Loading page...</div>}
              />
            </Document>
          )}
        </div>
      </div>
    </div>
  );
};

export default PDFViewer; 